import { z } from 'zod';

export const ActivityLogResourceSchema = z.enum([
  'gdpr',
  'webclient-config',
  'conversation',
  'agent',
  'inbox',
  'label',
  'response',
  'flow',
  'subflow',
  'validation',
  'revisions',
  'debug',
  'language',
  'platform-general',
  'platform-connection',
  'platform-member',
  'bot-user-mapping',
  'bot-user-timezone',
  'bot-user-streaming-response',
  'data-sources',
  'subflow-templates',
  'webclient-access',
  'trainer-ai',
  'ticket-deflection-feedback',
  'article-architect',
  'data-retention',
  'contact-lookup',
]);

export const ActivityLogActionSchema = z.enum([
  'started',
  'ended',
  'created',
  'deleted',
  'updated',
  'send',
  'invite',
  'set-active',
  'toggle',
  'synced',
  'triggered',
]);

export const ActivityLogSchema = z.object({
  action: ActivityLogActionSchema,
  resource: ActivityLogResourceSchema,
  date: z.date(),
  target: z.string(),
  agent: z.object({
    firstName: z.string().nullable().optional(),
    lastName: z.string().nullable().optional(),
    email: z.string().nullable(),
  }),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export const ActivityUserMetaDataSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
});
